<template>
  <QPage>
    <AuthTitleBtn
      :title="$t('ETAB.PAGES.STARTUP.WELCOME.@TITLE')"
      :first-btn-label="$t('ETAB.PAGES.STARTUP.WELCOME.@RIGHT_APP')"
      :second-btn-label="$t('ETAB.PAGES.STARTUP.WELCOME.@WRONG_APP')"
      :first-btn-action="goToRightApp"
      :second-btn-action="goToWrongApp"
    />
  </QPage>
</template>

<script>
  import AuthTitleBtn from "@etab/components/auth/AuthTitleBtn.component.vue";
  import { MetaHelpers } from "@core/helpers";
  import { ETAB_ROUTES } from "@etab/config";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { DataLayerManager } from "@core/managers/datalayer-manager";
  import { UserStorageManager } from "@core/managers/user-storage.manager";

  export default {
    components: {
      AuthTitleBtn,
    },
    meta() {
      return MetaHelpers.setAutoMeta({
        description: this.$t("ETAB.PAGES.SIGNUP.META.@DESCRIPTION"),
        canonical: `${window.location.origin}${window.location.pathname}${window.location.hash.split("?")[0]}`,
      });
    },
    mounted() {
      this.setTracker();
    },
    methods: {
      async setTracker() {
        const utmTrackerFromUrl = DataLayerManager.getUrlParamCampaign();
        const utmTrackerFromLocalStorage = await UserStorageManager.getUtmTracker();
        const utm_tracker = utmTrackerFromLocalStorage ?? utmTrackerFromUrl;
        if (utm_tracker) {
          UserStorageManager.setUtmTracker(utm_tracker);
        }
      },
      goToRightApp() {
        TrackingManager.addEvent({
          event: "landing_dispatch",
          cta: "step1_is_etab",
        });
        this.$router.push({ name: ETAB_ROUTES.auth.signup.name });
      },
      goToWrongApp() {
        TrackingManager.addEvent({
          event: "landing_dispatch",
          cta: "step1_is_candidate",
        });
        this.$router.push({ name: ETAB_ROUTES.auth.wrongApp.name });
      },
    },
  };
</script>
